import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const wattAmTagBellCurveReducer = (state = {
    WattAmTagBellCurveUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_WattAmTagBellCurve_wattAmTagBellCurveReducer":
            return { ...state, WattAmTagBellCurveUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, WattAmTagBellCurveUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default wattAmTagBellCurveReducer;
